var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41668 16.7665C8.19168 16.7665 7.98335 16.6749 7.82502 16.5249L1.70835 10.4082C1.38335 10.0832 1.38335 9.5582 1.70835 9.2332C2.03335 8.9082 2.55835 8.9082 2.88335 9.2332L8.39168 14.7415L17.125 5.31653C17.4417 4.97487 17.9667 4.9582 18.3 5.27487C18.6334 5.59153 18.6583 6.11653 18.3417 6.44987L9.01668 16.5082C8.86668 16.6749 8.65002 16.7749 8.42502 16.7749H8.40835L8.41668 16.7665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.ebca1e2509df7d018aaa2bfd8d939ba5.svg";
export { ForwardRef as ReactComponent };